// cli-positive-integer-option.ts
//
// Phase-01 (backlog NaN): `--max-ticks` used to flow through `Number(opts.
// maxTicks)` in the `run` action — `Number("abc")` is `NaN`, and the control
// loop's `for (i = 0; i < NaN; i++)` runs ZERO times, so `run` silently exits
// 1 as `outcome: "idle"` with no explanation. `0`, `-1`, and `1.5` slipped
// through the same way (loop runs 0 times, or a fractional tick count nobody
// asked for).
//
// Wiring this as a commander `.option("--max-ticks <n>", desc,
// parsePositiveTickCount)` parser makes the failure visible BEFORE the
// action runs — before resolveWorkspaceRoot/resolveMission/mission lock are
// ever touched (plan.md §Luật chung: "parser option chạy trước action").

import { InvalidArgumentError } from "commander";

/** Only a positive decimal integer, no leading zero-only forms, no sign, no fraction. */
const POSITIVE_INTEGER_PATTERN = /^[1-9]\d*$/;

/**
 * Parses `--max-ticks <raw>` into a positive integer. Throws commander's
 * `InvalidArgumentError` (caught by commander's own error handling — becomes
 * a clean CLI error, not an uncaught exception) for anything that is not a
 * bare positive decimal integer: non-numeric text, `0`, negative numbers,
 * fractions, and the empty string.
 */
export function parsePositiveTickCount(raw: string): number {
  if (!POSITIVE_INTEGER_PATTERN.test(raw)) {
    throw new InvalidArgumentError(
      `--max-ticks phải là số nguyên dương (vd. 1, 2, 10) — nhận "${raw}".`,
    );
  }
  return Number(raw);
}
